import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapPaymentRepairToServer } from "./mappers/mapPaymentRepairToServer";
export const removeRepairPayment = async (sessionKey, payment) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/payment`,
            method: "DELETE",
            data: mapPaymentRepairToServer(payment),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
